import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';

import { finalize, takeUntil } from 'rxjs';

import { GsapService } from '../../shared/animations/gsap.service';
import { OfferGroup } from '../../shared/data/models/collections/offer-group';
import { Request } from '../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss'],
})
export class OffersComponent extends AbstractLocalizedComponent implements OnInit, OnDestroy {
  @ViewChildren('revealBackElementRef') set revealBackElementRef(revealBackElementRef: QueryList<ElementRef<HTMLElement>>) {
    const revealBackElements: HTMLElement[] = revealBackElementRef.map(e => e.nativeElement);
    if (revealBackElements.length) {
      this.gsapService.set(revealBackElements, { opacity: 0, yPercent: 50 });
      revealBackElements.forEach((revealElement: HTMLElement) => {
        this.gsapService.createScrollTrigger({
          trigger: revealElement,
          start: 'top 90%',
          onEnter: () =>
            this.gsapService.timeline().to(revealElement, { opacity: 1, yPercent: 0, duration: 0.6, ease: this.gsapService.easeInOut() }),
          once: true,
        });
      });
    }
  }
  isLoading = true;
  offerGroups: OfferGroup[];
  showNavigation = true;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private gsapService: GsapService
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.breakpointObserver
      .observe(Breakpoints.XSmall)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((state: BreakpointState) => {
        this.showNavigation = !state.matches;
      });
  }

  protected loadData(locale: string): void {
    this.isLoading = true;
    this.collectionsService
      .query<{ offerGroups: OfferGroup[] }>(Request.OFFER_GROUPS, { locale })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(data => (this.offerGroups = data.offerGroups));
  }
}
